import { gql } from '@apollo/client';

const PatientInfoShared = gql`
  fragment PatientInfoShared on Patient {
    id
    firstName
    lastName
    dob
    birthDay
    birthMonth
    birthYear
    arches
    includeEot
    scanReady
    scanReadyAt
    scanSentAt
    partnerUploadScanAt
    sendToClinic
    consumedSendToClinic
    legacyId
    settingsOverride
    settingGroupOptionIds
    settingGroupOptions {
      id
      name
      settingGroup {
        id
        name
      }
    }
    notes
    accountId
    hasPlan
    hasFreeTrial
    retainerBank
    partnerOrganizationId
    partnerLocationId
    partnerLocation {
      id
      name
      settingGroupOptionIds
      address {
        id
        city
        region
      }
      enablePaidInOffice
    }
    account {
      id
      accountNumber
    }
    orders {
      id
    }
    referral {
      id
      state
      reminders
      consumedAt
      source
      sent
      sentAt
      hexCode
      partnerOrganizationId
      partnerOrganization {
        id
        name
      }
      partnerLocationId
      partnerLocation {
        id
        name
        address {
          id
          city
          region
        }
      }
      userId
      user {
        id
        firstName
        lastName
        email
      }
      createdAt
      updatedAt
    }
    createdAt
    updatedAt
  }
`;

export default PatientInfoShared;
